import React, { useState } from "react";
import { Button, Input, Modal, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { fetchSubmitSettlement } from "@redux/warehouseSlice";
import { AppDispatch } from "src/store";

interface SettlementRow {
  id: number;
  totalRequestQty: number;
  totalArrivedQty: number;
}

interface Props {
  row: SettlementRow;
  warehouseCode: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const SettlementButton = ({ row, warehouseCode, disabled, style, className }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [modalVisible, setModalVisible] = useState(false);
  const [memoInput, setMemoInput] = useState("");

  const handleClick = () => {
    if (row.totalRequestQty === row.totalArrivedQty) {
      dispatch(fetchSubmitSettlement({ purchaseId: row.id, warehouseCode }));
      return;
    }
    setMemoInput("");
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
    setMemoInput("");
  };

  const handleConfirm = () => {
    const trimmed = memoInput.trim();
    if (trimmed === "") {
      message.error("請輸入數量不一致原因");
      return;
    }
    if (trimmed.length < 5) {
      message.error("至少輸入5個字");
      return;
    }
    dispatch(fetchSubmitSettlement({ purchaseId: row.id, warehouseCode, memo: trimmed }));
    handleClose();
  };

  return (
    <>
      <Button type="link" disabled={disabled} onClick={handleClick} style={style} className={className}>
        上架完成
      </Button>
      <Modal
        title={
          <span>
            <ExclamationCircleOutlined style={{ color: "#faad14", marginRight: 8 }} />
            數量不一致原因
          </span>
        }
        open={modalVisible}
        onCancel={handleClose}
        footer={[
          <Button key="cancel" onClick={handleClose}>
            取消
          </Button>,
          <Button key="confirm" type="primary" onClick={handleConfirm}>
            確認
          </Button>,
        ]}
      >
        <Input.TextArea
          placeholder="至少輸入5個字"
          value={memoInput}
          onChange={(e) => setMemoInput(e.target.value)}
          rows={4}
        />
      </Modal>
    </>
  );
};

export default SettlementButton;
